// X216: which sign-in prompts (dialogs that open on their own) are up right now, so a second one waits instead of
// stacking on top. The club country question goes after the others (COUNTRY_PLAN.md §4.2): it opens only while none
// is open; the others check it too, so two never open at once whichever mounts first.
//   const slots = usePromptSlots();  slots.hold('mfaOffer', open)  ·  slots.othersOpen('clubCountry')
import {useState} from '#app';
import {watch} from 'vue';

export function usePromptSlots() {
  const open = useState('tl.promptSlots', () => ({}));

  const set = (name, isOpen) => {
    const next = {...open.value};
    if (isOpen) next[name] = true;
    else delete next[name];
    open.value = next;
  };

  /** Keeps `name` registered while the ref/getter `isOpen` is true. */
  const hold = (name, isOpen) => watch(isOpen, (v) => set(name, !!v), {immediate: true});

  const othersOpen = (name) => Object.keys(open.value).some((k) => k !== name);

  return {open, set, hold, othersOpen};
}
